import {SpotlightSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/sections.types';
import {useIsConsentBannerClosed} from '@aboutyou/storage';
import {SpotlightSlider as SpotlightSliderBase} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {BackgroundCard} from './BackgroundCard';
import {Slide} from './Slide';
import {useSpotlightSliderUniqueRenderKey} from './useSpotlightSliderUniqueRenderKey';
import {spotlightSliderHeightCSS} from './utils';

export const SpotlightSlider: FC<SpotlightSection & {isFetching?: boolean}> = ({
  elements,
  isFetching,
}) => {
  const isConsentBannerClosed = useIsConsentBannerClosed();
  const uniqueKey = useSpotlightSliderUniqueRenderKey(elements, isFetching);

  return (
    <Section>
      <SpotlightSliderBase
        slides={elements}
        CardComponent={Slide}
        BackgroundComponent={BackgroundCard}
        showNavigationButtons={true}
        uniqueKey={uniqueKey}
        isInitialAutoplayStopped={!isConsentBannerClosed}
      />
    </Section>
  );
};

const Section = styled.section`
  ${spotlightSliderHeightCSS};
`;
